module.exports = __webpack_public_path__ + "img/vue.3e7d6ca6.png";